import React from 'react';

const SpotifyEmbed = () => (
  <iframe
    style={{ borderRadius: '8px' }}
    src="https://open.spotify.com/embed/playlist/7p2roo9y1xPvRcND0Uvn8Q?utm_source=generator"
    width="100%"
    height="500"
    frameBorder="0"
    allowFullScreen=""
    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
    loading="lazy"
  ></iframe>
);

export default SpotifyEmbed;
